import { getBranchLocationActions } from './branchLocationAction'


const initialState = {
  //   accountTypeList:[],
  // companyTypeList: [],
  // constitutionList:[],
  // countriesList:[],
  // noOfEmployeesList: [],
  // officeInLocalityList: [],
  // officeOwnershipList:[],
  // pincodesList:[],
  branchLocation: {},
  // HeadOfficeDetails:{}

}


const branchLocationReducer = (state = initialState, action) => {

  switch (action.type) {


    case getBranchLocationActions.GET_BRANCH_LOCATION_DETAIL_SUCCESS:
      return {
        ...state,
        branchLocation: action.payload
      };
    default:
      return state;
  }

}




export default branchLocationReducer